<template>
  <div id="table-outer-container" @keydown.capture="stopKeyboardNavigation">

    <header>
      <button :title="strings.backToWorkspacesTitle" id="recent-workspace-btn" class="e-input-group-icon e-icons prev-button" @click="goBackToRecentWorkspaces"/>
      <h2>{{ strings.searchTitle }} <span>({{ category }})</span></h2>
      <home-nav/>
    </header>

    <search-table v-if="hasResultsToDisplay" />

    <spinner v-else-if="isLoading" />

    <template v-else>
      <section id="search-message">
        <p v-if="showNoResultsMessage">{{ strings.noResultsMessage }}</p>
        <template v-for="(error, index) in errors">
          <p :key="index">{{ error }}</p>
        </template>
      </section>
    </template>

  </div>
</template>

<script>
import HomeNav from '@/components/home/HomeNav'
import SearchTable from '@/components/search/SearchTable'
import Spinner from '@/components/common/Spinner'

import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      strings: {
        searchTitle: this.translate('search title'),
        backToWorkspacesTitle: this.translate('go back to recent workspaces'),
        noResultsMessage: this.translate('no results found')
      }
    }
  },
  components: {
    'home-nav': HomeNav,
    'spinner': Spinner,
    'search-table': SearchTable
  },
  computed: {
    ...mapGetters({
      getCategory: 'search/category',
      allSearchResults: 'search/allSearchResults',
      isLoading: 'search/isLoading',
      success: 'search/success',
      errors: 'search/errors'
    }),
    category () {
      let name = this.getCategory
      return this.translate(name)
    },
    hasResultsToDisplay () {
      return Array.isArray(this.allSearchResults) && this.allSearchResults.length > 0
    },
    showNoResultsMessage () {
      return !this.hasResultsToDisplay && this.success
    }
  },
  methods: {
    ...mapActions({
      navigateToRecentWorkspaces: 'search/goBackToRecentWorkspaces'
    }),
    stopKeyboardNavigation (event) {
      // Revert back to Browser Default Keyboard Navigation
      event.stopPropagation()
      return false
    },
    goBackToRecentWorkspaces () {
      this.navigateToRecentWorkspaces()
    },
    translate (string, object) {
      return this.$i18n.translate(string, object)
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/components/_search.scss";
</style>
